exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".temporary[data-v-4cc46f54]{text-align:center;padding:50px;border:1px solid #000}", ""]);

// exports
